import { call, put } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import {
  HideContactRequestAction,
  RefreshContactsRequestAction,
} from '../types';
import { checkResponse } from 'store/utils';

import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { hideContactFailure, hideContactSuccess } from '../actions';
import { hideContact } from '../api';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* hideContactSaga(action: HideContactRequestAction) {
  try {
    let err: ApiError | null;
    const { hideContactData, connectionId } = action.payload;

    const response: ApiResponse = yield call(hideContact, hideContactData, connectionId);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(hideContactSuccess(hideContactData));
    const message: MessageData = {
      title: i18n.t('common.success'),
      description: hideContactData.isActive
        ? i18n.t('notifications.contacts-now-visible')
        : i18n.t('notifications.contacts-now-hidden'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(hideContactFailure());
  }
}
